const getCarDisplayPrice = (carId, allPrices, currentServiceType = null) => {
  // Filter prices untuk mobil tertentu
  const carPrices = allPrices?.filter((p) => p.car_id === carId) || [];

  if (carPrices.length === 0) {
    return {
      price: 0,
      label: "Price Not Available",
      serviceType: null,
      condition: null,
    };
  }

  // Prioritas: Self Drive > Tour > Transfer Service

  // 1. Cek Self Drive
  const selfDrivePrices = carPrices.filter((p) => p.type === "self_drive" && p.condition_type === "default");

  // 2. Cek Tour Packages
  const tourPrices = carPrices.filter((p) => p.type === "tour" && p.condition_type === "default");

  // 3. Cek Transfer Service (Airport Transfer)
  const transferPrices = carPrices.filter((p) => p.type === "transfer_service" && p.condition_type === "default");

  // Jika user sedang memilih service type tertentu, prioritaskan itu
  if (currentServiceType) {
    if (currentServiceType === "self_drive" && selfDrivePrices.length > 0) {
      return {
        price: selfDrivePrices[0].price,
        label: "Daily Rate From",
        serviceType: "self_drive",
        condition: null,
      };
    }

    if (currentServiceType === "tour" && tourPrices.length > 0) {
      // Cari tour dengan jam yang sesuai
      const matchedTour = tourPrices.find((t) => t.condition?.hour === currentServiceType.tourHours);

      if (matchedTour) {
        return {
          price: matchedTour.price,
          label: `Tour Package /${matchedTour.condition.hour} Hours`,
          serviceType: "tour",
          condition: matchedTour.condition,
        };
      }
    }

    if (currentServiceType === "transfer_service" && transferPrices.length > 0) {
      // Ambil harga terendah untuk transfer service
      const lowestTransfer = transferPrices.reduce((min, p) => (p.price < min.price ? p : min));

      return {
        price: lowestTransfer.price,
        label: "Airport Transfer From",
        serviceType: "transfer_service",
        condition: lowestTransfer.condition,
      };
    }
  }

  // Logika default berdasarkan prioritas

  // Priority 1: Self Drive tersedia
  if (selfDrivePrices.length > 0) {
    return {
      price: selfDrivePrices[0].price,
      label: "Daily Rate From",
      serviceType: "self_drive",
      condition: null,
      availableServices: {
        selfDrive: true,
        tour: tourPrices.length > 0,
        transfer: transferPrices.length > 0,
      },
    };
  }

  // Priority 2: Hanya Tour tersedia
  if (tourPrices.length > 0 && selfDrivePrices.length === 0) {
    // Ambil harga terendah dari tour packages
    const lowestTour = tourPrices.reduce((min, p) => (p.price < min.price ? p : min));

    return {
      price: lowestTour.price,
      label: `Tour Package /${lowestTour.condition.hour} Hours`,
      serviceType: "tour",
      condition: lowestTour.condition,
      availableServices: {
        selfDrive: false,
        tour: true,
        transfer: transferPrices.length > 0,
      },
    };
  }

  // Priority 3: Hanya Transfer Service tersedia
  if (transferPrices.length > 0 && selfDrivePrices.length === 0 && tourPrices.length === 0) {
    // Ambil harga terendah untuk transfer service
    const lowestTransfer = transferPrices.reduce((min, p) => (p.price < min.price ? p : min));

    return {
      price: lowestTransfer.price,
      label: "Airport Transfer From",
      serviceType: "transfer_service",
      condition: lowestTransfer.condition,
      availableServices: {
        selfDrive: false,
        tour: false,
        transfer: true,
      },
    };
  }

  // Fallback
  return {
    price: 0,
    label: "Contact for Price",
    serviceType: null,
    condition: null,
    availableServices: {
      selfDrive: false,
      tour: false,
      transfer: false,
    },
  };
};

// Fungsi untuk mendapatkan semua layanan yang tersedia untuk mobil
const getAvailableServices = (carId, allPrices) => {
  const carPrices = allPrices?.filter((p) => p.car_id === carId) || [];

  return {
    selfDrive: carPrices.some((p) => p.type === "self_drive"),
    tour: carPrices.some((p) => p.type === "tour"),
    tourPackages: carPrices
      .filter((p) => p.type === "tour")
      .map((p) => ({
        hours: p.condition?.hour,
        price: p.price,
      })),
    transfer: carPrices.some((p) => p.type === "transfer_service"),
    transferAreas: carPrices
      .filter((p) => p.type === "transfer_service")
      .map((p) => ({
        area: p.condition?.areas,
        price: p.price,
      })),
  };
};

// Export functions
export { getCarDisplayPrice, getAvailableServices };
